import { Title } from '@mantine/core'
import { Button } from '@seen/ui'
import { IconExternalLink } from '@tabler/icons-react'
import type { JSX } from 'react'
import { Link } from '#src/components/core/Link.tsx'
import { useCurrentCarePlanURL } from '#src/hooks/useCurrentCarePlanURL.ts'

export function SDRUpdateCarePlan(): JSX.Element {
  const currentCarePlanURL = useCurrentCarePlanURL().data

  return (
    <div className="flex items-center justify-between">
      <Title order={4}>Update Care Plan</Title>
      <Button asChild>
        <Link to={currentCarePlanURL}>
          <IconExternalLink className="size-4" />
          Go To Care Plan
        </Link>
      </Button>
    </div>
  )
}
